__turbopack_context__.v({
  "className": "Owo3bG_className",
  "variable": "Owo3bG_variable",
});
